export interface GalleryImage {
  id: number;
  title: string;
  category: string;
  height: string;
  image: string;
}

export const galleryImages: GalleryImage[] = [
  {
    id: 1,
    title: "Windsor Heritage Lounge Set",
    category: "Living",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/8f14b2ea-70a0-4b54-ba71-1636aaf274ac_Sofa-1-5S-1.jpeg?v=bc0be77cacd38e7a61b38c86d33da907",
  },
  {
    id: 2,
    title: "Regency Classic Living Suite",
    category: "Living",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/ba606d0f-5d3c-435d-ba9b-06653175972d_Sofa-2-5S-1.jpeg?v=b8250a032ac1686d90a68d47d086c9e5",
  },
  {
    id: 3,
    title: "Cambridge Compact Sofa",
    category: "Living",
    height: "short",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/f4a7a808-9edf-4538-97a0-a1500ab47c92_Sofa-3-4S-1.jpeg?v=9dfd75d5a675c0b302a38ee2485b9a86",
  },
  {
    id: 4,
    title: "Victorian Carved Lounge Sofa",
    category: "Living",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/aaa0224c-dacf-4251-8ef7-f5c97c5e7a9f_Sofa-4-5S-1.jpeg?v=67eb29b5ca05f430462e0ea27d5f00ef",
  },
  {
    id: 48,
    title: "The Florentine Heritage Console",
    category: "Custom Orders",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/ba9cdb49-db34-4c73-8654-859e7fe8bb66_custom-order-1-1.jpeg?v=f9ada90645f36a29023cbecaf257fd7f",
  },
  {
    id: 49,
    title: "The Grand Atelier Sideboard",
    category: "Custom Orders",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/6104b3fb-cb3a-4dd6-bd5a-804bd20e444c_custom-order-2-1.jpeg?v=17a6b818a0bac22fa4595706d5ab41db",
  },
  {
    id: 50,
    title: "The Imperial Reflection Mirror Frame",
    category: "Custom Orders",
    height: "short",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/7c4c86cd-c300-428c-adec-f59bb828099f_custom-order-3-1.jpeg?v=f04997be9710daafeb3817ecc21df674",
  },
  {
    id: 51,
    title: "The Artisan Display Cabinet",
    category: "Custom Orders",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/e00fb52f-29e0-42b3-8fca-283f67abce1b_custom-order-4-1.jpeg?v=55fc9b4ef21ab1433efb3c01fd0fe1d9",
  },
  {
    id: 52,
    title: "The Regal Dressing Console",
    category: "Custom Orders",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/e1611b6d-08d4-4d6e-9bed-73bde907efb8_custom-order-5-1.jpeg?v=8561b30e10a48220e9abae0c29049de3",
  },
  {
    id: 53,
    title: "The Classic Heritage Storage Unit",
    category: "Custom Orders",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/1c1cc76f-23aa-464c-8ab9-21245755fcc2_custom-order-6-1.jpeg?v=52931f44cede053add32d39aceddc9df",
  },
  {
    id: 60,
    title: "The Aurelia Heritage Armchair",
    category: "Signature Pieces",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/cb88c659-fe73-4058-9daf-1c79cf5dbea8_signature-1-1.jpeg?v=1af49ba1af32f2701b717cfd42317305",
  },
  {
    id: 61,
    title: "The Windsor Cane Accent Chair",
    category: "Signature Pieces",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/f95aeb69-afe5-4b28-ab8e-3d22160a3c24_signature-2-1.jpeg?v=c21066af108cb9061d83b943bd10d0c2",
  },
  {
    id: 62,
    title: "The Regent Lounge Sofa",
    category: "Signature Pieces",
    height: "short",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/7f2ee730-c337-4bac-a2dc-62342e552c31_signature-3-1.jpeg?v=342a0abbd63fb2c2b4504fe1a7107401",
  },
  {
    id: 63,
    title: "The Imperial Carved Salon Set",
    category: "Signature Pieces",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/6e2f94f1-5a13-4374-b083-5beb8498f63a_signature-4-1.jpeg?v=6bba9f0eac4b35f9f98225a8d0c6a282",
  },
  {
    id: 19,
    title: "Versailles Cane Heritage Bed",
    category: "Bedroom",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/d6191fdd-ad37-47cb-b26b-f0a514a2f221_Bed-1.jpeg?v=bc824356f97ba9d221b98003d23ebeb5",
  },
  {
    id: 20,
    title: "Windsor Upholstered Classic Bed",
    category: "Bedroom",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/734a1e62-9eeb-46e6-90a4-cf11fccf08fa_Bed-2.jpeg?v=6eb98af2f3d52a12dc39b9ce9d627a19",
  },
  {
    id: 21,
    title: "Regency Carved Panel Bed",
    category: "Bedroom",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/ef9306f8-5a04-4c29-8625-0c4dcfa23818_Bed-3.jpeg?v=7742dfd51fde03cad108774f27aa9816",
  },
  {
    id: 22,
    title: "Imperial Leatherback Sleigh Bed",
    category: "Bedroom",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/7866dc43-1388-4586-96ae-b571b65689bb_Bed-4.jpeg?v=909a83a35fa6ca4aaa840d94905a9360",
  },
  {
    id: 23,
    title: "Louis XV Velvet Frame Bed",
    category: "Bedroom",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/b2dc7860-3aa5-49c6-8808-e72b61de7400_Bed-5.jpeg?v=6fff5b4985d8da47b05aa50990fb91b2",
  },
  {
    id: 24,
    title: "Heritage Manor Panel Bed",
    category: "Bedroom",
    height: "short",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/776ea5fd-a992-44b7-b957-c81430a2a4c8_Bed-6.jpeg?v=4a944a3a7fd61423f597c2077a649944",
  },
  {
    id: 25,
    title: "Victorian Grand Estate Bed",
    category: "Bedroom",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/77f1a9d2-b841-4956-b5b4-597227618ddf_Bed-7.jpeg?v=51bc3cae5028301fefae2bee72a64422",
  },
  {
    id: 26,
    title: "Classic Regency Sleigh Bed",
    category: "Bedroom",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/0c71a1ef-769b-43c6-9895-98d5c838af86_Bed-8.jpeg?v=e28ea7dbd03f7840df9c34681646c61a",
  },
  {
    id: 27,
    title: "Royal Cane Panel Bed",
    category: "Bedroom",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/eca8a631-c569-44b3-88d3-3096500d6f45_Bed-9.jpeg?v=24a0fbc79958e9ed702b86be418344f2",
  },
  {
    id: 28,
    title: "Chesterfield Tufted Heritage Bed",
    category: "Bedroom",
    height: "short",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/58bd0aa9-6c66-4179-96e5-896a95553edd_Bed-10.jpeg?v=462d4c0788f51ea733457a13b1d5020a",
  },
  {
    id: 29,
    title: "Edwardian Panel Heritage Bed",
    category: "Bedroom",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/f162601b-070f-4485-99db-adf308fb8860_bed-11.jpeg?v=a244c144cbf4438b0e54286a3006afb1",
  },
  {
    id: 30,
    title: "French Regency Sleigh Bed",
    category: "Bedroom",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/9a19c5ed-aeaf-4d41-aebe-45b0fa103f30_Bed-12.jpeg?v=d2a9a3d99d083b77fb5aed7cb516010a",
  },
  {
    id: 31,
    title: "Contemporary Heritage Platform Bed",
    category: "Bedroom",
    height: "short",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/00710b01-2cb8-4dd1-a302-3ac367f66eaa_Bed-13.jpeg?v=aa0994e2d5c81e5ac3123ad81ae7cfd9",
  },
  {
    id: 32,
    title: "Victorian Carved Estate Bed",
    category: "Bedroom",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/e7929f67-f205-4869-b322-f749bf2317d3_Bed-14.jpeg?v=8efbc2999268a7de0239559705cd3e62",
  },
  {
    id: 33,
    title: "Louis XVI Classic Frame Bed",
    category: "Bedroom",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/413f840d-07bf-4160-b506-1317ec203d54_Bed-15.jpeg?v=74d80e0d84a2cf39d8ae106ed47c7a49",
  },
  {
    id: 34,
    title: "Chesterfield Upholstered Grand Bed",
    category: "Bedroom",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/cdaa34ee-80e2-457c-95e5-52818fb3646e_Bed-16.jpeg?v=49df26a9322b154e63037c38a12173b8",
  },
  {
    id: 35,
    title: "Manor House Classic Panel Bed",
    category: "Bedroom",
    height: "short",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/8a6827a6-3682-43b1-be7f-68123af9c87e_Bed-17.jpeg?v=cf8c095627af53297b8d3724f282ef26",
  },
  {
    id: 36,
    title: "Imperial Sleigh Signature Bed",
    category: "Bedroom",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/f5a583f0-a700-4978-9cb3-48f2240766cb_Bed-18.jpeg?v=75192626179f307edd6c548e3826c904",
  },
  {
    id: 37,
    title: "Classic Heritage Upholstered Bed",
    category: "Bedroom",
    height: "short",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/fce0989c-7dd1-48fe-8ae1-87118f4c76dc_Bed-19.jpeg?v=234266781b92a796be4201989ccb0420",
  },
  {
    id: 38,
    title: "Royal Heritage Dining Set",
    category: "Dining",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/35d585f8-6e61-4396-868c-7627af3a834d_Dining-1.jpeg?v=f13ae27f007fc5352927dcdbf3b614e4",
  },
  {
    id: 39,
    title: "Imperial Carved Dining Collection",
    category: "Dining",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/22d83833-5ea0-4c1e-8020-6666b60c0ffc_Dining-2.jpeg?v=31da5cea14f61ad69f83d21868ce9c94",
  },
  {
    id: 40,
    title: "Victorian Grand Dining Ensemble",
    category: "Dining",
    height: "short",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/48acd214-b38a-4ab3-9dc4-b6002353aacd_Dining-3.jpeg?v=164f2c4176d37d9f796249a26ed0c4b3",
  },
  {
    id: 41,
    title: "Regal Artisan Dining Table",
    category: "Dining",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/bec0709b-1242-4aa3-8f77-9e81326fb77a_Dining-4.jpeg?v=bc2f06d69739bc69333706260bc0734d",
  },
  {
    id: 42,
    title: "Classic Walnut Dining Suite",
    category: "Dining",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/9eab8645-6be8-4e5a-b1f0-ef190be3fc7d_Dining-5.jpeg?v=80c1f1768d59cfe2f7b1bad9ad43c955",
  },
  {
    id: 43,
    title: "Heritage Oak Dining Collection",
    category: "Dining",
    height: "short",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/8dc99a86-d139-440b-bc20-c93db05e3b1f_Dining-6.jpeg?v=c1ead0fb19860966a2a997995b60210f",
  },
  {
    id: 44,
    title: "Majestic Carved Dining Set",
    category: "Dining",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/fcd6f642-cf7a-41ed-88f7-de371e38d2df_Dining-7.jpeg?v=4ca00c8fbe2e1a9570e3e59addcb4e93",
  },
  {
    id: 45,
    title: "Sovereign Teak Dining Ensemble",
    category: "Dining",
    height: "medium",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/d9e6cce5-2329-4533-806c-0d74066d512c_Dining-8.jpeg?v=873b85c5b803443dcbe051025277bcb1",
  },
  {
    id: 46,
    title: "Aristocrat Panel Dining Suite",
    category: "Dining",
    height: "short",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/9ee327f6-edbf-43b8-bd44-e7cc4842f9b9_Dining-9.jpeg?v=c0b831ea9ac3f579a46f152ed9650766",
  },
  {
    id: 47,
    title: "Estate Mahogany Dining Collection",
    category: "Dining",
    height: "tall",
    image: "https://storage.readdy-site.link/project_files/ceb959ad-084b-4c4d-b2df-b0c971f3a270/cb0df03c-ec8e-462b-a105-bd950a2dc963_Dining-10.jpeg?v=c18aea416ce3ca9b97c78a4e77fd02e9",
  },
];

export const galleryCategories = ["All", "Living", "Bedroom", "Dining", "Custom Orders", "Signature Pieces"];
